import {
  BulkInviteAssignableRole,
  ExtendField,
  ExtendFieldKey,
} from 'src/app/BulkInvite/bulkInvite.types'
import { OrganizationRoles } from 'src/enums'

// The core fields a CSV column can be mapped onto: email*, name, and phone.
// `aliases` drive fuzzy auto-mapping against the messy real-world headers HRIS
// exports produce. `labelKey` is the i18n key (identical to its en-US message).
export const EXTEND_FIELDS: ExtendField[] = [
  {
    key: 'email',
    labelKey: 'Email',
    required: true,
    aliases: [
      'email',
      'e-mail',
      'work email',
      'workemail',
      'email address',
      'work email address',
      'company email',
      'business email',
    ],
  },
  {
    key: 'firstName',
    labelKey: 'First name',
    required: false,
    aliases: [
      'first name',
      'firstname',
      'first',
      'fname',
      'given name',
      'givenname',
      'legal first name',
      'preferred first name',
    ],
  },
  {
    key: 'lastName',
    labelKey: 'Last name',
    required: false,
    aliases: [
      'last name',
      'lastname',
      'last',
      'lname',
      'surname',
      'family name',
      'familyname',
      'legal last name',
    ],
  },
  {
    key: 'phone',
    labelKey: 'Phone',
    required: false,
    aliases: [
      'phone',
      'phone number',
      'mobile',
      'mobile number',
      'mobile phone',
      'cell',
      'cell phone',
      'telephone',
      'work phone',
      'contact number',
    ],
  },
  {
    key: 'role',
    labelKey: 'Role',
    required: false,
    aliases: [
      'role',
      'user role',
      'organization role',
      'org role',
      'extend role',
      'member role',
      'admin role',
      'bookkeeper role',
      'card manager role',
      'card_manager',
      'card-manager',
      'cardmanager',
    ],
  },
]

export const REQUIRED_FIELD_KEYS: ExtendFieldKey[] = EXTEND_FIELDS.filter(
  (f) => f.required,
).map((f) => f.key)

export const BULK_INVITE_ASSIGNABLE_ROLES: BulkInviteAssignableRole[] = [
  OrganizationRoles.member,
  OrganizationRoles.bookkeeper,
  OrganizationRoles.cardManager,
  OrganizationRoles.admin,
]

export const DEFAULT_IMPORT_ROLE = OrganizationRoles.member

// Max file size accepted by the upload step.
export const MAX_FILE_SIZE_MB = 10
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

export const TEMPLATE_FILE_NAME = 'extend-bulk-invite-template.csv'

// Headers for the downloadable empty template.
export const TEMPLATE_HEADERS = [
  'Email',
  'First name',
  'Last name',
  'Phone',
  'Role',
]
